import { useState } from 'react';

interface FaqItem {
  q: string;
  a: string;
}

interface FaqAccordionProps {
  items: FaqItem[];
  defaultOpen?: number | null;
}

export default function FaqAccordion({ items, defaultOpen = 0 }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);

  return (
    <ul className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <li key={item.q}>
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : index)}
              aria-expanded={isOpen}
              className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer group"
            >
              <span
                className={`text-sm md:text-base leading-relaxed transition-colors ${
                  isOpen ? 'text-primary-500' : 'text-foreground-900 group-hover:text-primary-500'
                }`}
              >
                {item.q}
              </span>
              <span
                className={`mt-0.5 w-7 h-7 shrink-0 flex items-center justify-center rounded-full border transition-colors ${
                  isOpen
                    ? 'border-primary-500 text-primary-500'
                    : 'border-background-300 text-foreground-600'
                }`}
              >
                <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
              </span>
            </button>
            {isOpen && (
              <p className="pb-6 pr-10 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
            )}
          </li>
        );
      })}
    </ul>
  );
}